import { useQuery } from "@tanstack/react-query";
import { ksRevuesNumeriquesQK } from "../lib/query-keys";
import axiosClient from "../lib/axiosClient";
import { RevueNumerique } from "../lib/interfaces/revue-numerique.interface";
import Title from "../components/ui/Title";
import RevueNumeriqueItem from "../components/revues-numeriques/RevueNumeriqueItem";
import { Skeleton } from "../components/ui/skeleton";
import GooglePlayIcon from "../assets/img/googleplay.png";
import AppStoreIcon from "../assets/img/appstore.png";
import { Info } from "lucide-react";

export default function RevuesNumeriquesPage() {
  const { data: revuesNumeriques } = useQuery({
    queryKey: [ksRevuesNumeriquesQK],
    queryFn: async () => {
      const { data } = await axiosClient.get<RevueNumerique[]>(`/revues-numeriques/for-user`);
      return data;
    },
  });

  return (
    <div>
      <Title className='mb-6'>Revues numérique</Title>

      <div className='text-sm items-center flex flex-row gap-2 md:gap-5 text-slate-500 mb-6 p-3 rounded-md bg-white border-2'>
        <Info className='w-6 h-6' />
        <div>
          <div>Les revues numériques sont généralement disponibles entre le 5 et le 10 du mois.</div>
          <div className='hidden md:block'>
            Pour plus de confort de lecture, téléchargez l'application <em>L'Abeille de France</em> pour les tablettes
            et smartphones.
          </div>
        </div>
      </div>

      <div className='mb-6 p-3 bg-white border rounded-md flex flex-col gap-2 md:hidden'>
        <div className='text-sm'>
          Pour plus de confort de lecture, téléchargez l'application <em>L'Abeille de France</em> pour les tablettes et
          smartphones.
        </div>
        <div className='flex flex-col sm:flex-row gap-4'>
          <a href='https://play.google.com/store/apps/details?id=com.labeilledefrance.revue' target='_blank'>
            <img src={GooglePlayIcon} alt='Google Play' className='max-w-48' />
          </a>
          <a href='https://apps.apple.com/fr/app/labeille-de-france/id6739069067' target='_blank'>
            <img src={AppStoreIcon} alt='App Store' className='max-w-48 mt-0.5' />
          </a>
        </div>
      </div>

      <div className='space-y-4'>
        {!revuesNumeriques ? (
          <>
            <Skeleton className='w-[630px] h-40' />
            <Skeleton className='w-[630px] h-40' />
            <Skeleton className='w-[630px] h-40' />
          </>
        ) : (
          revuesNumeriques.map((revue) => <RevueNumeriqueItem key={revue.id} revue={revue} />)
        )}
        {revuesNumeriques && revuesNumeriques.length === 0 && (
          <div className='rounded bg-white p-4 text-slate-700'>Vous n'avez accès à aucune revue numérique.</div>
        )}
      </div>
    </div>
  );
}
